import getCookie from '../common/getCookieValue'
import getURLParameter from '../common/getURLParameter'

let spm = getCookie('spm') || ''
const { wechatJump = '', creativeid = '' } = getURLParameter()

let isMobile = false
if (navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|IEMobile)/i)) {
    isMobile = true
}

export const justOpenMini = (spmArr, barFlag) => {
    // 移动端url参数wechatJump为1时且页面为招聘聚合页时（且为oppo时）跳转
    if (isMobile && wechatJump === '1' && spmArr.some(el => spm.includes(el)) && creativeid === '1') {
        // spm拼接
        if (!spm.includes('.cid_')) {
            const outtraceid = getCookie('outtraceid')
            outtraceid && (spm = `${spm}.cid_${outtraceid}`)
        }
        const storage = window.sessionStorage;
        if (!barFlag && storage && storage.getItem('wechatJump')) {
            return;
        } else if (storage) {
            storage.setItem('wechatJump', 1);
        }
        // 目前只有这一个页面所以写死了，后续再有可以做成配置项
        const path = 'pages/zhaopin/index/index'
        const query = `spm=${spm}`
        $.ajax({
            type: 'get',
            url: '/wchat/scheme',
            data: {
                path,
                query
            },
            dataType: 'json',
            success: (res) => {
                if (res.data && res.code === 1 && typeof(res.data) === 'string') {
                    location.href = res.data
                    // const ifrm = document.createElement("iframe");
                    // ifrm.src =  res.openlink
                    // ifrm.style.display = "none";
                    // document.body.appendChild(ifrm);
                } else {
                    console.log('获取schema错误：', res)
                }
            }
        })
    }
}
